import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';
import { Observable } from 'rxjs';

import { I18nTranslator } from '../../../../i18n/translate';
import { ARBleOrder, ARBleOrderItem } from '../../../../models/agrorendement-ble.model';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe';
import { HectareConverterPipe } from '../../../../pipes/hectareConverter.pipe';
import { ARBleService } from '../../../../services/agrorendement-ble.service';
import { ParcelService } from '../../../../services/parcel.service';
import { PreventDoubleClickDirective } from '../../../../utils/preventDoubleClick';
import { AROrderEditComponent } from '../common/order-edit.component';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'ar-ble-order-edit',
  templateUrl: '../common/order-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, PreventDoubleClickDirective, CampaignYearPipe, CapitalizePipe, HectareConverterPipe, TranslatePipe, TranslateWithPunctuationPipe, CommonModule, FormsModule],
  providers: [ARBleService, ParcelService],
})
export class ARBleOrderEditComponent
  extends AROrderEditComponent<ARBleOrder, ARBleOrderItem>
  implements OnInit, OnDestroy
{
  @Input() orderItem: ARBleOrderItem;

  constructor(
    protected service: ARBleService,
    protected parcelService: ParcelService,
    protected i18nTranslator: I18nTranslator,
    protected modal: ModalService,
    protected router: Router,
    protected route: ActivatedRoute,
  ) {
    super();
    this.specyString = this.i18nTranslator.translate('ar.ble.section');
    this.specyUrlPart = ['azote', 'ble'];
    this.specyIconClass = 'fa-bullseye';
    this.specyOrderCode = 'ORDB';
    this.routeActionIndex = 4;
    this.toolStatusCode = 'ARBle';
  }

  buildNew(): ARBleOrder {
    return new ARBleOrder();
  }

  remoteGetOrderItems(orderItemIds: Array<number>): Observable<ARBleOrderItem[]> {
    return this.service.getOrderItems(orderItemIds, null, null, true);
  }

  remoteGetOrderItem(orderItemId: number): Observable<ARBleOrderItem> {
    return this.service.getOrderItem(orderItemId);
  }
}
